/*
 * bz-zero-vat-modal.js
 * Hinweis-Popup zur 0-%-Umsatzsteuer (§ 12 Abs. 3 UStG).
 * Öffnet AUSSCHLIESSLICH per Klick auf den markierten „0 %"-Link im Steuerhinweis —
 * KEIN automatisches Öffnen beim Seitenaufruf oder beim Wechsel auf 0 %.
 *
 * Datengetrieben über data-vat-rate der aktiven .bz-segment-input (steuert die Marker-Sichtbarkeit).
 * KEINE Prüfung auf sichtbare Texte, Optionspositionen oder Kundentyp-Namen.
 * Verändert NICHT: Preis, Steuer, Varianten, Kundentyp-Sync, Warenkorb, ATC.
 * Alle sichtbaren Texte kommen aus dem Snippet (Locale-Keys), nicht aus diesem JS.
 */
(function () {
  'use strict';

  var modal, dialog, reopenBtn, lastFocused, restoreOverflow;

  // Numerische Normalisierung: "0", "0.0", "0,0", "0 %", "0%" -> 0
  function normalizeRate(raw) {
    if (raw === null || raw === undefined) return NaN;
    var s = String(raw).replace(/%/g, '').replace(/\s+/g, '').replace(',', '.');
    if (s === '') return NaN;
    var n = parseFloat(s);
    return isNaN(n) ? NaN : n;
  }

  function activeSegment() {
    return document.querySelector('.bz-segment-input:checked');
  }

  function isZeroActive() {
    var seg = activeSegment();
    if (!seg || !seg.hasAttribute('data-vat-rate')) return false;
    return normalizeRate(seg.getAttribute('data-vat-rate')) === 0;
  }

  function getFocusable() {
    return Array.prototype.slice.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input:not([disabled]), select, summary, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeModal();
      return;
    }
    if (e.key === 'Tab') {
      var f = getFocusable();
      if (!f.length) { e.preventDefault(); dialog.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  }

  function openModal(trigger) {
    if (!modal || modal.getAttribute('aria-hidden') === 'false') return;
    lastFocused = trigger || activeSegment() || document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    // Scroll-Lock
    restoreOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown, true);
    // Fokus in den Dialog (X-Button zuerst)
    var focusTarget = dialog.querySelector('.bz-zvm__x') || dialog;
    window.requestAnimationFrame(function () { focusTarget.focus(); });
  }

  function closeModal() {
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = restoreOverflow || '';
    document.removeEventListener('keydown', onKeydown, true);
    // Fokus zurück auf Auslöser (Radio-Button oder Reopen-Link).
    // Deferred via rAF: das Verstecken (display:none) triggert eine Browser-Fokus-Fixup,
    // die ein synchrones focus() sonst überschreiben würde.
    var toFocus = lastFocused;
    if (toFocus && typeof toFocus.focus === 'function') {
      window.requestAnimationFrame(function () {
        if (document.contains(toFocus)) {
          try { toFocus.focus(); } catch (e) {}
        }
      });
    }
  }

  // Markiert bei aktiver 0-%-Auswahl das „0 %" IM bestehenden Steuerhinweis (#bz-price-note)
  // als sichtbaren, klickbaren Link, der dasselbe Popup öffnet. Bei ≠ 0 % wird die Markierung entfernt.
  // bz-price-tax-note.liquid und bz-customer-type.js bleiben unangetastet; re-markiert nach deren Text-Update.
  function markPriceNote() {
    var note = document.getElementById('bz-price-note');
    if (!note || !modal) return;
    var existing = note.querySelector('.bz-zvm-mark');

    if (!isZeroActive()) {
      if (existing) { note.textContent = note.textContent; } // Markierung entfernen -> reiner Text
      reopenBtn = null;
      return;
    }
    if (existing) { reopenBtn = existing; return; } // schon markiert

    var text = note.textContent;
    var m = text.match(/0\s*%/); // erste „0 %"/„0%"-Fundstelle
    if (!m) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bz-zvm-mark';
    btn.id = 'bz-zvm-reopen';
    btn.setAttribute('aria-label', modal.getAttribute('data-zvm-reopen-label') || m[0]);
    btn.textContent = m[0];
    btn.addEventListener('click', function () { openModal(btn); });

    note.textContent = '';
    note.appendChild(document.createTextNode(text.slice(0, m.index)));
    note.appendChild(btn);
    note.appendChild(document.createTextNode(text.slice(m.index + m[0].length)));
    reopenBtn = btn;
  }

  function wireCloseControls() {
    // Backdrop + alle [data-zvm-close]-Elemente schließen (nur Hinweis, keine Varianten-/Steueränderung)
    modal.addEventListener('click', function (e) {
      var closer = e.target.closest ? e.target.closest('[data-zvm-close]') : null;
      if (closer) { e.preventDefault(); closeModal(); }
    });
  }

  function init() {
    modal = document.getElementById('bz-zero-vat-modal');
    if (!modal) return; // Snippet nicht vorhanden -> nichts tun (z. B. Zubehör-PDP)
    dialog = modal.querySelector('.bz-zvm__dialog');
    if (!dialog) return;

    wireCloseControls();
    markPriceNote();

    // Eigener Listener — bz-customer-type.js bleibt unangetastet (läuft davor und setzt den Note-Text).
    // Aktualisiert NUR die Sichtbarkeit/Markierung des „0 %"-Links, öffnet NICHT automatisch.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('bz-segment-input')) {
        markPriceNote();
      }
    });

    // Re-Markierung, nachdem bz-customer-type.js seine DOMContentLoaded-Init den Note-Text neu gesetzt hat.
    document.addEventListener('DOMContentLoaded', markPriceNote);
    window.addEventListener('load', markPriceNote);
    // Kein automatisches Öffnen — das Popup öffnet ausschließlich per Klick auf den „0 %"-Link.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
